<template>
   <section class="homecategories">
      <div class="container">
         <div class="homecategories__title">
            <h4>Let's get going. <span>Breathe.</span> And go again.</h4>
            <p>Fun and energetic, Crystalbrook Flynn makes you feel like you’re at the centre of the action – prepare to be entertained. Just steps from the Esplanade boardwalk, there is always a DJ ready to play and a martini ready to be shaken.</p>
         </div>
         <div class="homecategories__wrap">
            
            <a class="homecategories__item" @click='navigate(cat)' v-for="cat in category" :key="cat.id">
               <div class="homecategories__item-img" v-bind:style="{ background: 'url(' + cat.linkAvatar + ')' + 'no-repeat center center' }"></div>
               <div class="homecategories__item-content">
                  <h5 href="#">{{ cat.linkText }}</h5>
               </div>
            </a>

         </div>
      </div>
   </section>
</template>

<script>
   import { CATEGORIES } from '../js/categories.js';

   export default {
      name: 'HomeCategories',
      data: function() {
         return {
            category: CATEGORIES
         }
      },

      methods: {
         navigate (cat) {
            let params = { urlSegment: cat.urlSegment, id: cat.id, screenId: this.$router.currentRoute.params.screenId }
            this.$router.push({ name: 'category', params: params})
         }
      },
   }
</script>
